<template>
  <v-container v-if="currentRepairFile" fluid>
    <v-row>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" md="4">
            <div class="title-content">
              <p class="boomerang-id">
                {{
                  $t('REPAIR_FILE_DETAIL.INTERNAL_COMMAND_NUMBER') +
                  currentRepairFile.internal_command_number
                }}
              </p>
              <p class="collaborator">
                {{ getFormatedFullName(currentRepairFile.requestor_collaborator_fullname) }}
              </p>
            </div>
          </v-col>
          <v-col cols="12" md="8">
            <div class="rounded-xl header-info">
              <p class="store-name">
                {{ $t('REPAIR_FILE_DETAIL.STORE') + currentRepairFile.store_name }}
              </p>
              <p class="bold-text">
                {{
                  currentRepairFile.company
                    ? $t('REPAIR_FILE_DETAIL.CLIENT_COMPANY_NAME') + currentRepairFile.company
                    : $t('REPAIR_FILE_DETAIL.CLIENT_COMPANY_NAME') + $t('COMMON.NO_VALUE')
                }}
              </p>
              <p class="creation-date">
                {{ removeTimeFromDate(currentRepairFile.business_created_at) }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12" md="10">
            <div class="status-content">
              {{ getStatusMacroTranslation(currentRepairFile.status_macro) }}
            </div>
          </v-col>
          <v-col class="d-flex justify-end" cols="12" md="2">
            <div class="button">
              <button @click="this.$router.push({ name: 'Dashboard' })">
                <img alt="cross-svg" class="close-btn" src="@/assets/icons/file/cross.svg" />
              </button>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="rentalFileId">
      <v-col cols="2" class="pb-0 pt-0">
        <div class="header-rental-container">
          <div class="repair repair-selected pl-3 pr-3">
            {{ $t('REPAIR_FILE_DETAIL.HEADER_RENTAL.REPAIR') }}
          </div>
          <div class="rental pl-3 pr-3" @click="redirectToRentalFileDetail()">
            {{ $t('REPAIR_FILE_DETAIL.HEADER_RENTAL.RENTAL') }}
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12">
            <GlobalRepairFileInfo
              :currentRepairFile="currentRepairFile"
              @updateCurrentRepairFile="handleUpdateRepairFile()"
            />
          </v-col>
          <v-col cols="12">
            <AttachmentRepairFile :currentRepairFile="currentRepairFile" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <CommentaryRepairFile :currentRepairFile="currentRepairFile" />
          </v-col>
          <v-col cols="12">
            <InformationRepairFile :currentRepairFile="currentRepairFile" />
          </v-col>
          <v-col cols="12">
            <TransporterRepairFile :currentRepairFile="currentRepairFile" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GlobalRepairFileInfo from '@/components/repair-file-module/folder-lifecycle/GlobalRepairFileInfo.vue'
import CommentaryRepairFile from '@/components/repair-file-module/folder-lifecycle/CommentaryRepairFile.vue'
import AttachmentRepairFile from '@/components/repair-file-module/folder-lifecycle/AttachmentRepairFile.vue'
import TransporterRepairFile from '@/components/repair-file-module/folder-lifecycle/TransporterRepairFile.vue'
import InformationRepairFile from '@/components/repair-file-module/folder-lifecycle/InformationRepairFile.vue'
import RepairFileService from '@/services/RepairFileService'
import RepairFileStatusMacroConstant from '@/constants/repairFileStatusMacroConstant'
import { checkPermission, displayToast } from '@/components/utils/globalFunction'
import RentalFileService from '@/services/rentalModule/RentalFileService'

export default {
  name: 'RepairFileDetailPage',
  components: {
    InformationRepairFile,
    TransporterRepairFile,
    AttachmentRepairFile,
    CommentaryRepairFile,
    GlobalRepairFileInfo
  },
  data() {
    return {
      loading: false,
      error: null,

      currentRepairFile: null,
      rentalFileId: null
    }
  },

  async created() {
    await this.getRepairFile()

    if (checkPermission(['DISTRIBUTOR_RENTAL_READ'])) {
      await this.getRentalFileId()
    }
  },
  methods: {
    handleUpdateRepairFile() {
      this.getRepairFile()
    },
    getFormatedFullName(fullName) {
      const words = fullName.split(' ')
      let initials = ''
      initials += words[1].charAt(0).toUpperCase() + '.'
      return words[0] + ' ' + initials
    },
    removeTimeFromDate(dateString) {
      if (!this.currentRepairFile.business_created_at) {
        return ''
      }
      const date = new Date(dateString)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()

      return `${day}/${month}/${year}`
    },
    getStatusMacroTranslation(statusMacro) {
      switch (statusMacro) {
        case RepairFileStatusMacroConstant.IN_CREATION:
          return this.$t('COMMON.STATUS_MACRO.IN_CREATION')
        case RepairFileStatusMacroConstant.IN_CREATION_PROSPECT:
          return this.$t('COMMON.STATUS_MACRO.IN_CREATION_PROSPECT')
        case RepairFileStatusMacroConstant.IN_CREATION_ESTIMATE:
          return this.$t('COMMON.STATUS_MACRO.IN_CREATION_ESTIMATE')
        case RepairFileStatusMacroConstant.TRANSPORT_GO:
          return this.$t('COMMON.STATUS_MACRO.TRANSPORT_GO')
        case RepairFileStatusMacroConstant.RECEPTION_AT_REPAIRER:
          return this.$t('COMMON.STATUS_MACRO.RECEPTION_AT_REPAIRER')
        case RepairFileStatusMacroConstant.DIAGNOSTIC_MANUFACTURER_RECEIVED:
          return this.$t('COMMON.STATUS_MACRO.DIAGNOSTIC_MANUFACTURER_RECEIVED')
        case RepairFileStatusMacroConstant.DIAGNOSTIC_MANUFACTURER_PROCESSED:
          return this.$t('COMMON.STATUS_MACRO.DIAGNOSTIC_MANUFACTURER_PROCESSED')
        case RepairFileStatusMacroConstant.ESTIMATE_SENT_TO_CUSTOMER:
          return this.$t('COMMON.STATUS_MACRO.ESTIMATE_SENT_TO_CUSTOMER')
        case RepairFileStatusMacroConstant.ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER:
          return this.$t('COMMON.STATUS_MACRO.ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER')
        case RepairFileStatusMacroConstant.IN_REPARATION:
          return this.$t('COMMON.STATUS_MACRO.IN_REPARATION')
        case RepairFileStatusMacroConstant.SENT_BACK_BY_REPAIRER:
          return this.$t('COMMON.STATUS_MACRO.SENT_BACK_BY_REPAIRER')
        case RepairFileStatusMacroConstant.RECEIPT_AT_STORE:
          return this.$t('COMMON.STATUS_MACRO.RECEIPT_AT_STORE')
        case RepairFileStatusMacroConstant.SENT_AVAILABLE_TO_CUSTOMER:
          return this.$t('COMMON.STATUS_MACRO.SENT_AVAILABLE_TO_CUSTOMER')
        case RepairFileStatusMacroConstant.TAKEOVER_BY_CUSTOMER:
          return this.$t('COMMON.STATUS_MACRO.TAKEOVER_BY_CUSTOMER')
        case RepairFileStatusMacroConstant.FINISHED:
          return this.$t('COMMON.STATUS_MACRO.FINISHED')
        case RepairFileStatusMacroConstant.ABORT_BY_CUSTOMER:
          return this.$t('COMMON.STATUS_MACRO.ABORT_BY_CUSTOMER')
        case RepairFileStatusMacroConstant.DELETED:
          return this.$t('COMMON.STATUS_MACRO.DELETED')
        default:
          this.$router.push({ name: 'Dashboard' })
          displayToast(this.$t('REPAIR_FILE_DETAIL.MESSAGE.STATUS_MACRO_UNKNOWN'), 'error')
      }
    },
    async getRepairFile() {
      try {
        this.currentRepairFile = await RepairFileService.get(
          this.$route.params.repairFileBoomerangId
        )

        if (this.currentRepairFile.status_macro === RepairFileStatusMacroConstant.DRAFT) {
          this.$router.push({ name: 'Dashboard' })
          displayToast(this.$t('REPAIR_FILE_DETAIL.MESSAGE.DRAFT'), 'error')
        } else if (this.currentRepairFile.status_macro === RepairFileStatusMacroConstant.DELETED) {
          this.$router.push({ name: 'Dashboard' })
          displayToast(this.$t('REPAIR_FILE_DETAIL.MESSAGE.DELETED'), 'error')
        }
      } catch (error) {
        this.$router.push({ name: 'Dashboard' })
        displayToast(this.$t('REPAIR_FILE_DETAIL.MESSAGE.NOT_FOUND'), 'error')
      }
    },
    async getRentalFileId() {
      try {
        const response = await RentalFileService.getRentalFileByRepairFileId(
          this.currentRepairFile.technical_id
        )
        this.rentalFileId = response.rental_file_id
      } catch (error) {
        this.rentalFileId = null
        // Do Nothing
      }
    },
    redirectToRentalFileDetail() {
      this.$router.push('/rental-module/rental-file-detail/' + this.rentalFileId)
    }
  }
}
</script>

<style scoped>
.v-container {
  padding: 50px 40px 40px;
}

.title-content {
  display: flex;
  align-items: baseline;
  gap: 20px;
}

.collaborator {
  text-transform: capitalize;
  color: #acacac;
  text-align: center;
  padding: unset;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  alignment-baseline: baseline;
}

.boomerang-id {
  padding: unset;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.header-info {
  .v-container {
    padding: 50px 40px 40px;
  }

  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}

.store-name {
  margin-left: 0;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.bold-text {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  text-transform: capitalize;
}

.creation-date {
  color: #acacac;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.status-content {
  color: black;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  border: white;
  background: white;
}

.button {
  display: flex;
}

.close-btn {
  display: flex;
  padding: 10px;
  background: white;
  border-radius: 60px;
}

.header-rental-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  background-color: #86c94e;
  border-radius: 100px;
  padding: 10px;
  min-width: 200px;

  .repair-selected {
    background-color: #ffffff;
  }

  .repair {
    cursor: default;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    padding: 5px 20px 5px 20px;
    border-radius: 50px;
    gap: 10px;
  }

  .rental {
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    padding: 5px 20px 5px 20px;
    border-radius: 50px;
    gap: 10px;
  }
}
</style>
